import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import { Button } from 'components'

const LifeErrorCommon = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: "",
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding center-cont">
				<i className="icon icon_error_tri" />
				<h3 className="intro-tit mt_20">정보수집 오류가 발생했어요.</h3>
				<span className="intro-sub-tit mt_10">다시 시도해주세요.</span>
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big">다시 수집하기</Button>
			</div>
		</div>
	)
}

export default LifeErrorCommon